<script setup>
import { computed, ref } from 'vue';
import { Icon, Button } from '@components'

import { useRouter } from 'vue-router';
const router = useRouter()

import { useSetup } from '@store/setup';
const $setup = useSetup();

import {useSettings} from '@store/settings';
const $settings = useSettings();

const useTypes = computed(() => {
    return [
        { name: 'Business',
         description: 'Great for salons, spas, and other businesses.',
         img:'setup-business.png',
         btnTxt:'Get Started',
         btnFunction:async()=>{
            // $setup.setup.type = 'business'
            //  $settings.settings.addons.staffs = true
             $settings.addons['staffs'] = true;
             $setup.isBusiness = true
             await $settings.saveSettings('addons', $settings.addons)
             await $setup.saveSetupStep('info')
            router.push({name:'setup.info'})
         },
         btnStyle:'primary'
        },
        { name: 'Individual',
         description: 'Ideal for freelancers, coaches, and 1-on-1 services.',
         img:'setup-personal.png',
         btnTxt:'Get Started',
         btnFunction:async()=>{
            // $setup.setup.type = 'personal'
            //  $settings.settings.addons.staffs = false
             $settings.addons['staffs'] = false;
             $setup.isBusiness = false
             await $settings.saveSettings('addons', $settings.addons)
             await $setup.saveSetupStep('info')
            router.push({name:'setup.info'})
         },
         btnStyle:'secondary_gray'
        },
    ]
})
</script>


<template>
    <div class="md:max-w-[633px] mx-auto flex flex-col justify-between items-center p-3 md:p-0 m-2">
        <Icon name="logoLight" size="86px" class="mt-3 md:mt-[83px]" />
        <h1 class="text-xl lg:text-2xl font-semibold text-[#101828] mt-[47px]">Welcome to PreBook!</h1>
        <p class="text-sm md:text-base font-normal text-[#667085] mt-3 text-center">Thank you for choosing PreBook! Let’s set up your booking system in a few simple steps. You can skip optional steps and configure them later.</p>
        <h2 class="text-sm md:text-lg font-medium text-[#101828] mt-[50px]">Are you using PreBook as an individual user or a business?</h2>
        <div class="w-full flex flex-col md:flex-row justify-between gap-6 mt-5 mb-8">
            <div class="w-full lg:w-[290px] flex flex-col items-center border-2 border-[#EAECF0] rounded-[10px] px-6 pt-[34px] pb-[38px]" v-for="type in useTypes" :key="type.name">
                <p class="text-lg font-semibold text-[#101828]">{{ type.name }}</p>
                <img :src="Image(type.img)" alt="" class="mt-5 w-[205px]" />
                <p class="text-sm font-normal text-[#344054] mt-5 w-[177px] text-center">{{ type.description }}</p>
                <button @click="type.btnFunction()" class="w-full mt-5 border border-[#D0D5DD] hover:border-[#7F56D9] hover:bg-[#7F56D9] bg-white px-5 py-3 rounded-lg text-[#344054] hover:text-white shadow-[0px_1px_2px_0px_#1018280D] text-base font-semibold transition-all duration-300">{{ type.btnTxt }}</button>
            </div>
        </div>
    </div>  
</template> 

<style>

</style>